<script>
    /* Copyright (c) 2021 Jacques Desodt */

    /* This component contains two parts:
     > the title: always visible.
     > the content: shown / hidden, depending on the user choice.

     This component must be encapsulated by a parent Accordion component.
     The parent Accordion sets the display animation of this component.

     Note: this component is unstyled by default.
     The application is responsible for the the look and feel.
     For the best usability, see:
     https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
     */

    /* The boolean value set to open this component when loaded */
    export let openAfterLoad = false; // closed by default

    /* This DOM element */
    let domElement = false;

    /* The name of the accordion ID attribute */
    const accordionIdAttributeName = 'data-accordion-id';
    /* The name of the dispatch name attribute */
    const dispatchNameAttributeName = 'data-accordion-dispatch-name';

    /* Handles this title part click event */
    const handleClick = () => {
        /* Gets this attributes values */
        const accordionId = domElement.getAttribute(accordionIdAttributeName);
        const dispatchName = domElement.getAttribute(dispatchNameAttributeName);
        /* Creates the custom event with the configurable dispatch name */
        const event = new CustomEvent(dispatchName, {detail: domElement});
        /* Sends the custom event to the accordion parent */
        document.getElementById(accordionId).dispatchEvent(event);
    };
</script>

<!-- TITLE PART
    On mount, the parent Accordion component will set these attributes:

    > data-accordion-dispatch-name
    > data-accordion-id
    > data-accordion-item-index
    > the transition style
-->
<div
        bind:this={domElement}
        data-accordion-dispatch-name="click"
        data-accordion-item-index={0}
        on:click|preventDefault|stopPropagation={handleClick}
        {openAfterLoad}
>
    <!-- Slot: the application can insert any code -->
    <slot name="title"/>
</div>

<!-- CONTENT PART
  This part is hidden by default.
  On mount, the parent Accordion component will display this part if openAfterLoad = true.
-->
<div class="accordion-content hide">
    <!-- Slot: the application can insert any code -->
    <slot name="content"/>
</div>

<!-- Manages the show / hide display with CSS. See:
    https://gomakethings.com/how-to-add-transition-animations-to-vanilla-javascript-show-and-hide-methods/
-->
<style>
    .accordion-content {
        height: auto;
        opacity: 1;
        overflow: hidden;
    }

    .accordion-content.hide {
        height: 0;
        opacity: 0;
    }
</style>
